import { render, staticRenderFns } from "./MediaPage.vue?vue&type=template&id=1ce84d36&scoped=true"
import script from "./MediaPage.vue?vue&type=script&lang=js"
export * from "./MediaPage.vue?vue&type=script&lang=js"
import style0 from "./MediaPage.vue?vue&type=style&index=0&id=1ce84d36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce84d36",
  null
  
)

export default component.exports